<template>
  <div>
    <b-row v-if="isMobileVersion" class="m-0"
      ><b-col class="col-12 p-0">
        <b-btn
          variant="light"
          class="col-12 toolbar-colapse-btn"
          @click="
            if (contextAssistantActive) {
              showToolbarContextHelp();
            } else {
              toolbarCollapsed = !toolbarCollapsed;
            }
          "
          ><span
            class="oi oi-menu text-secondary cursor-pointer"
            title="Geokoduj adres"
            aria-hidden="true"
          ></span></b-btn></b-col
    ></b-row>

    <b-collapse id="map-toolbar" :visible="isToolbarVisible">
      <b-row class="m-1 flex-nowrap">
        <div md="auto">
          <b-button-toolbar key-nav class="map-toolbar">
            <b-button-group
              class="mb-1 d-flex flex-wrap"
              v-if="showButtonGroupA"
            >
              <b-button-group :class="isMobileDevice ? '' : 'mr-1'">
                <b-btn
                  title="Poprzedni widok"
                  variant="primary"
                  @click.prevent="moveBack"
                  v-bind:class="{ disabled: preventMoveBack }"
                  v-if="moveBackTool && !isMobileVersion"
                >
                  <icon name="reply"></icon>
                </b-btn>
                <b-btn
                  title="Następny widok"
                  variant="primary"
                  @click.prevent="moveForward"
                  v-bind:class="{ disabled: preventMoveForward }"
                  v-if="moveForwardTool && !isMobileVersion"
                >
                  <icon name="share"></icon>
                </b-btn>
                <b-btn
                  title="Zmiana centrum widoku"
                  variant="primary"
                  @click.prevent="setCentre"
                  v-if="setCentreTool && !isMobileVersion"
                >
                  <icon name="crosshairs"></icon>
                </b-btn>
                <b-btn
                  title="Przybliż do własnego zasięgu"
                  variant="primary"
                  class="btn btn-primary"
                  @click.prevent="showZoomToOwnRangeModal"
                  v-if="zoomToOwnRangeTool && !isMobileVersion"
                >
                  <span class="oi oi-target"></span>
                </b-btn>
                <b-btn
                  title="Cały zasięg"
                  variant="primary"
                  @click.prevent="showFullRange"
                  v-if="fullRangeTool && !isMobileVersion"
                >
                  <icon name="arrows-alt"></icon>
                </b-btn>
                <b-btn
                  title="Mapa przeglądowa"
                  variant="primary"
                  @click.prevent="showOverviewMap"
                  v-if="overviewMapTool && false"
                >
                  <icon name="map"></icon>
                </b-btn>
                <b-btn
                  title="Zakładki przestrzenne"
                  variant="primary"
                  v-if="spatialTabsTool && !isMobileVersion"
                  @click.prevent="showSpatialTabs"
                >
                  <icon name="compass"></icon>
                </b-btn>
                <b-btn
                  title="Wyszukiwanie"
                  variant="primary"
                  v-if="anySearchTool"
                  @click.prevent="toggleSearchPanelVisibility"
                >
                  <icon name="search"></icon>
                </b-btn>
                <b-btn
                  v-if="!isMobileVersion"
                  title="Przybliżanie prostokątem"
                  :variant="zoomMode ? 'warning' : 'primary'"
                  @click.prevent="toggleZoomMode"
                >
                  <icon name="search-plus"></icon>
                </b-btn>
                <auth-b-btn
                  title="Wyświetlanie stanu mapy na dany dzień"
                  variant="primary"
                  @click="showHistoricalData"
                  v-if="mapStateTool && false"
                  :permissionId="'Data_history'"
                  :disabled="editSession"
                >
                  <icon name="clock"></icon>
                </auth-b-btn>
                <auth-b-btn
                  title="Zgłoś prośbę o dane archiwalne"
                  variant="primary"
                  @click.prevent="showAskForArchiveData"
                  v-if="archivedDataRequestTool && !readOnly && false"
                  :permissionId="'Request_for_archive_data'"
                  :disabled="editSession"
                >
                  <icon name="archive"></icon>
                </auth-b-btn>
                <b-btn
                  title="Dodaj warstwę z usługi"
                  variant="primary"
                  @click.prevent="showAddLayerFromService"
                  v-if="addLayerFromServiceTool && !readOnly && false"
                  :disabled="editSession"
                >
                  <icon name="globe"></icon>
                </b-btn>
                <b-btn
                  title="Dodaj warstwę z pliku"
                  variant="primary"
                  @click.prevent="showAddLayerFromFile"
                  v-if="addLayerFromFileTool && !readOnly && false"
                >
                  <icon name="plus"></icon>
                </b-btn>
                <b-btn
                  title="Skróty klawiszowe"
                  variant="primary"
                  @click.prevent="showMapShortcuts"
                  v-if="keyboardShortcutsTool && !isMobileVersion"
                >
                  <icon name="keyboard"></icon>
                </b-btn>
                <b-btn
                  title="Informacje o obiekcie"
                  :variant="getFeatureInfoEnabled ? 'warning' : 'primary'"
                  :disabled="editSession"
                  @click.prevent="startFeatureInfo"
                >
                  <icon name="info"></icon>
                </b-btn>
                <b-btn
                  id="mapPrintout"
                  ref="mapPrintoutRef"
                  title="Wydruk mapy"
                  variant="primary"
                  @click="mapPrintoutClick"
                  v-if="!isMobileVersion"
                >
                  <icon name="print"></icon>
                </b-btn>
                <b-popover
                  target="mapPrintout"
                  triggers="click blur"
                  placement="auto"
                  @hidden="mapPrintoutPopoverHidden"
                >
                  <template slot="title"> Wydruk mapy </template>
                  <div>
                    <b-btn
                      variant="primary"
                      @click="downloadMap({ format: 'pdf' })"
                      >PDF</b-btn
                    >
                    <b-btn
                      variant="primary"
                      @click="downloadMap({ format: 'jpg' })"
                      >JPG</b-btn
                    >
                    <b-btn
                      variant="primary"
                      @click="downloadMap({ format: 'png' })"
                      >PNG</b-btn
                    >
                  </div>
                </b-popover>
                <b-btn
                  v-if="!isMobileVersion"
                  title="Dane systemowe w czasie"
                  :variant="historyTimelineActive ? 'warning' : 'primary'"
                  :disabled="editSession"
                  @click.prevent="togglehistoryTimelineActive"
                >
                  <icon name="clock"></icon>
                </b-btn>
              </b-button-group>
              <b-button-group :class="isMobileDevice ? '' : 'mr-1'">
                <b-btn
                  v-show="!measurementPopoverVisible"
                  title="Narzędzia pomiarowe"
                  variant="primary"
                  v-if="measurementTool && !isMobileVersion"
                  @click="measurementToolClick"
                >
                  <icon name="pencil-ruler"></icon>
                </b-btn>
                <b-btn
                  v-show="measurementPopoverVisible"
                  id="measurementTool"
                  ref="measurementToolda"
                  title="Narzędzia pomiarowe"
                  variant="primary"
                  v-if="measurementTool"
                >
                  <icon name="pencil-ruler"></icon>
                </b-btn>
                <b-popover
                  target="measurementTool"
                  triggers="click blur"
                  placement="auto"
                  @hidden="measurementPopoverHidden"
                >
                  <template slot="title"> Narzędzie pomiarowe </template>
                  <div>
                    <b-form-group
                      label="Jednostka pomiaru"
                      label-for="measurementUnitSelect"
                    >
                      <b-form-select
                        id="measurementUnitSelect"
                        v-model="measurementUnit"
                        :options="measurementUnitOptions"
                      />
                    </b-form-group>
                    <b-form-group
                      label="Rodzaj pomiaru"
                      label-for="measurementsButtonGroup"
                    >
                      <b-button-group
                        id="measurementsButtonGroup"
                        class="col-md-12 p-0"
                      >
                        <b-btn
                          class="col-md-6"
                          variant="primary"
                          title="Pomiar odległości"
                          @click="startMeasurement('LineString')"
                        >
                          <icon name="ruler-combined"></icon>
                        </b-btn>
                        <b-btn
                          class="col-md-6"
                          variant="primary"
                          title="Pomiar powierzchni"
                          @click="startMeasurement('Polygon')"
                        >
                          <icon name="draw-polygon"></icon>
                        </b-btn>
                      </b-button-group>
                    </b-form-group>
                  </div>
                </b-popover>
                <b-btn
                  title="Zatwierdź zaznaczenie"
                  variant="success"
                  v-if="rangeSelectionActive"
                  @click="deactivateRangeSelection"
                >
                  <icon name="check"></icon>
                </b-btn>
                <b-btn
                  title="Generowanie permalinku"
                  variant="primary"
                  @click="mapPermalinkModalShow"
                >
                  <icon name="link"></icon>
                </b-btn>
                <b-btn
                  title="Zgłoszenie popytu"
                  variant="primary"
                  v-if="!editSession"
                  :variant="getReportingDemandEnabled ? 'info' : 'primary'"
                  @click="requestNotification"
                >
                  <icon name="hand-paper"></icon>
                </b-btn>
                <b-btn
                  title="Eksport zgłoszonego popytu"
                  variant="primary"
                  @click.prevent="exportDemand"
                  v-if="!editSession && !isMobileVersion"
                >
                  <icon name="file-download"></icon>
                </b-btn>
                <b-btn
                  title="Zasilenie manualne"
                  variant="primary"
                  v-if="editItemTool && !readOnly && !isMobileVersion"
                  @click.prevent="activateEditSession"
                  :disabled="editSession || disableEditSessionActions"
                >
                  <icon name="pencil-alt"></icon>
                </b-btn>
              </b-button-group>
              <b-button-group
                :class="isMobileDevice ? '' : 'mr-1'"
                v-if="
                  editSession &&
                  activeLayerGeometryColumns &&
                  activeLayerGeometryColumns.column
                "
              >
                <b-btn
                  title="Dodaj obiekt"
                  :variant="
                    this.manualImportMapTools.add ? 'warning' : 'primary'
                  "
                  v-if="addItemTool"
                  @click="addFeature"
                >
                  <icon name="plus"></icon>
                </b-btn>
                <b-btn
                  title="Edytuj obiekt"
                  :variant="
                    this.manualImportMapTools.edit ? 'warning' : 'primary'
                  "
                  @click="editFeature"
                >
                  <icon name="project-diagram"></icon>
                </b-btn>
                <b-btn
                  title="Usuń obiekt"
                  :variant="
                    this.manualImportMapTools.delete ? 'warning' : 'primary'
                  "
                  @click="deleteFeature"
                >
                  <icon name="trash"></icon>
                </b-btn>
                <b-btn
                  title="Zaznacz obiekt"
                  :variant="
                    this.manualImportMapTools.select ? 'warning' : 'primary'
                  "
                  v-if="selectItemTool"
                  @click="toggleSelectMode(pointSelect)"
                >
                  <icon name="mouse-pointer"></icon>
                </b-btn>
                <b-btn
                  title="Kopiuj"
                  variant="primary"
                  @click="copyFeature"
                  :disabled="
                    selectedFeatures.length === 0 || featuresAreCopying
                  "
                >
                  <icon v-if="!featuresAreCopying" name="copy"></icon>
                  <span v-else><icon name="circle-notch" spin /></span>
                </b-btn>
              </b-button-group>
              <b-button-group v-if="!isMobileVersion">
                <b-btn
                  class="custom-margin"
                  title="Tabela atrybutów"
                  variant="primary"
                  @click="toggleAttributesTable"
                  v-if="!contextIsAnonymous && !isMobileVersion"
                >
                  Tabela atrybutów
                </b-btn>
                <b-link
                  href="#"
                  @click="goToAdminPanel()"
                  :disabled="editSession"
                >
                  <b-btn
                    class="right-border"
                    title="Panel zarządzania"
                    variant="primary"
                    v-if="(adminPanelTool && !isMobileVersion) || true"
                    :disabled="editSession"
                  >
                    <p v-if="isMobileDevice" class="m-0">Panel zarządzania</p>
                    <p v-else class="m-0">Panel zarządzania</p>
                  </b-btn>
                </b-link>
              </b-button-group>
            </b-button-group>
            <confirmation-window ref="confirmationWindow"></confirmation-window>
            <loading-overlay
              :active.sync="showLoadingOverlay"
              :is-full-page="true"
            ></loading-overlay>
          </b-button-toolbar>
        </div>
        <div v-if="editSession" class="ml-auto">
          <h4 class="font-weight-bold edit-mode-header ml-2 mr-auto">
            Tryb edycji
          </h4>
        </div>
        <div class="pr-0 ml-auto">
          <b-btn
            variant="warning"
            class="float-right"
            v-if="
              reportDiscrepancyTool & !readOnly &&
              $context.hasPermission('Discrepancies_registry')
            "
            @click="toggleMismatchApplicationVisibility"
            :disabled="editSession"
          >
            <p v-if="isMobileDevice" class="m-0">Zgłoś</p>
            <p v-else class="m-0">Zgłoś rozbieżność</p>
          </b-btn>
        </div></b-row
      >
    </b-collapse>
  </div>
</template>

<script>
import {
  CONNECTION_ANALYSIS_TOGGLE,
  FEATURES_TABLE_TOGGLE,
  LEFT_RESIZABLE_PANEL_EXPAND_CHANGE,
  MANUAL_IMPORT_PANEL_VISIBLE_SET,
  MAP_ZOOM_MODE_TOGGLE,
  MEASUREMENTS_ENABLED_SET,
  REPORTS_RANGE_SELECTION_ACTIVATE,
  SEARCH_PANEL_TOGGLE_VISIBILITY,
  SELECT_MULTIPLE_ACTIVATE,
  SPATIAL_ANALYSIS_SHOW_MODAL,
  TOGGLE_HISTORY_TIMELINE_ACTIVE,
  WINDOW_ADD_LAYER_FROM_SERVICE_SHOW,
  WINDOW_ASK_FOR_ARCHIVE_DATA_SHOW,
  WINDOW_DEMAND_EXPORT_SHOW,
  WINDOW_GET_LAYER_FROM_FILE_SHOW,
  WINDOW_MAP_PERMALINK_MODAL_SHOW,
  WINDOW_MAP_SHORTCUTS_SHOW,
  WINDOW_NOTIFICATION_SHOW,
  WINDOW_SET_CENTRE_SHOW,
  WINDOW_ZOOM_TO_OWN_RANGE_SHOW,
} from '../store/mutations.type';

import {
  BEGIN_POLE_ANALYSIS,
  BEGIN_ROAD_LANE_ANALYSIS,
  CANCEL_POLE_ANALYSIS,
  DISPLAY_CONTEXT_ASSISTANT_MESSAGE,
  EDIT_SESSION_START,
  MEASUREMENTS_ENABLE,
  SPATIAL_TABS_SHOW_MODAL,
  STOP_ROAD_LANE_ANALYSIS,
  TOGGLE_GET_FEATURE_INFO,
  TOGGLE_REPORT_DEMAND,
} from '../store/actions.type';

import { mapGetters } from 'vuex';
import { KeyShortcuts } from '../common/keyShortcuts';
import {
  MODE_POINT,
  MODE_POLYGON,
  MODE_RECTANGLE,
} from '../common/selectModes';
import ConfirmationWindow from './ConfirmationWindow.vue';

import LoadingOverlay from 'vue-loading-overlay';
import { Api as SearchApi } from '../api/api-wyszukiwarka';

export default {
  name: 'MapHorizontalToolbar',
  props: {
    disableEditSessionActions: {
      required: true,
      type: Boolean,
    },
    activeLayerType: null,
    isEditing: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      pointSelect: MODE_POINT,
      rectangleSelect: MODE_RECTANGLE,
      polygonSelect: MODE_POLYGON,
      showLoadingOverlay: false,
      measurementUnitOptions: [
        { value: 'm', text: 'metry' },
        { value: 'km', text: 'kilometry' },
      ],
      measurementUnit: 'm',
      measurementPopoverVisible: false,
      mapPrintoutPopoverVisible: false,
      isDataFeedImportModeActive: false,
      isNoGeometryLayerImportModeActive: false,
      adminPanel: '/admin/',
      toolbarCollapsed: false,
    };
  },
  components: {
    ConfirmationWindow,
    LoadingOverlay,
  },
  computed: {
    preventMoveBack: function () {
      return this.$store.getters.currentViewIndex <= 0;
    },
    preventMoveForward: function () {
      return (
        this.$store.getters.currentViewIndex >=
        this.$store.getters.views.length - 1
      );
    },
    ...mapGetters([
      'isDeleteMode',
      'moveBackTool',
      'moveForwardTool',
      'features',
      'activeLayerGeometryColumns',
      'setCentreTool',
      'demandFormTool',
      'demandExportTool',
      'fullRangeTool',
      'overviewMapTool',
      'spatialTabsTool',
      'mapStateTool',
      'archivedDataRequestTool',
      'addLayerFromServiceTool',
      'addLayerFromFileTool',
      'roadLaneCostAnalysisTool',
      'polesCostAnalysisTool',
      'spatialAnalysisTool',
      'measurementTool',
      'editItemTool',
      'copyItemTool',
      'selectItemTool',
      'addItemTool',
      'moveToArchiveTool',
      'removePermanentlyTool',
      'anySearchTool',
      'rangeSelectionActive',
      'keyboardShortcutsTool',
      'adminPanelTool',
      'measurementsEnabled',
      'broadbandConnectivityAnalysisTool',
      'isSelectModePoint',
      'isSelectModePolygon',
      'isSelectModeRectangle',
      'isSelectModeNone',
      'zoomToOwnRangeTool',
      'poleAnalysisReady',
      'isMobileWidth',
      'roadLaneAnalysisStarted',
      'editSession',
      'readOnly',
      'connectionAnalysisLaunched',
      'setFeatureGeometryTool',
      'setFeatureGeometryActive',
      'getFeatureInfoEnabled',
      'getReportingDemandEnabled',
      'replaceGeometryInProgress',
      'dataFeedId',
      'dataFeedNoGeometryLayerId',
      'selectedFeatures',
      'manualImportMapTools',
      'zoomMode',
      'reportDiscrepancyTool',
      'isMobileVersion',
      'isMobileDevice',
      'searchPanelVisible',
      'leftResizablePanelExpanded',
      'rightResizablePanelExpanded',
      'contextAssistantActive',
      'historyTimelineActive',
      'layersLoading',
      'featuresAreCopying',
      'ifModifyMenuVisible',
    ]),
    manyFeaturesSelected() {
      return this.selectedFeatures.length > 1;
    },
    showButtonGroupA() {
      return (
        this.moveBackTool ||
        this.moveForwardTool ||
        this.setCentreTool ||
        this.demandFormTool ||
        this.demandExportTool ||
        this.fullRangeTool ||
        this.overviewMapTool ||
        this.spatialTabsTool ||
        this.anySearchTool ||
        this.mapStateTool ||
        this.anySearchTool ||
        this.mapStateTool ||
        this.archivedDataRequestTool ||
        this.addLayerFromServiceTool ||
        this.addLayerFromFileTool ||
        this.keyboardShortcutsTool ||
        this.zoomToOwnRangeTool
      );
    },
    showButtonGroupB() {
      return (
        this.roadLaneCostAnalysisTool ||
        this.polesCostAnalysisTool ||
        this.spatialAnalysisTool ||
        this.broadbandConnectivityAnalysisTool
      );
    },
    showButtonGroupC() {
      return (
        this.measurementTool ||
        this.editItemTool ||
        this.copyItemTool ||
        this.selectItemTool ||
        this.addItemTool ||
        this.moveToArchiveTool ||
        this.setFeatureGeometryTool
      );
    },
    showeditSessionButtons() {},
    showRemovePermanentlyTool() {
      return (
        this.removePermanentlyTool &&
        this.editSession &&
        this.isImportModeActive
      );
    },
    showMoveToArchiveTool() {
      return (
        this.moveToArchiveTool && this.editSession && !this.isImportModeActive
      );
    },
    isImportModeActive() {
      return (
        this.isDataFeedImportModeActive ||
        this.isNoGeometryLayerImportModeActive
      );
    },
    isToolbarVisible() {
      return this.toolbarCollapsed || !this.isMobileVersion;
    },
  },
  watch: {
    dataFeedId: function (value) {
      this.isDataFeedImportModeActive = value == null ? false : true;
    },
    dataFeedNoGeometryLayerId: function (value) {
      this.isNoGeometryLayerImportModeActive = value == null ? false : true;
    },
  },
  methods: {
    goToAdminPanel() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie tego przycisku przekieruje użytkownika do panelu zarządzania.',
        });
      } else {
        window.console.log(window.location.origin + this.adminPanel);
        window.location = window.location.origin + this.adminPanel;
      }
    },
    toggleSearchPanelVisibility() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie tego przycisku włączy lub wyłączy narzędzie wyszukiwania.',
        });
      } else {
        if (this.isMobileDevice) {
          if (this.searchPanelVisible && !this.leftResizablePanelExpanded) {
            this.$store.commit(LEFT_RESIZABLE_PANEL_EXPAND_CHANGE, true);
          } else {
            this.$store.commit(SEARCH_PANEL_TOGGLE_VISIBILITY);
          }
        } else {
          this.$store.commit(SEARCH_PANEL_TOGGLE_VISIBILITY);
        }
      }
    },
    moveBack() {
      this.$emit('move-back');
    },
    moveForward() {
      this.$emit('move-forward');
    },
    setCentre() {
      this.$store.commit(WINDOW_SET_CENTRE_SHOW);
    },
    mapPermalinkModalShow() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie tego przycisku otworzy narzędzie do generowania permalinków do innych aplikacji mapowych.',
        });
      } else {
        this.$store.commit(WINDOW_MAP_PERMALINK_MODAL_SHOW);
      }
    },
    exportDemand() {
      this.$store.commit(WINDOW_DEMAND_EXPORT_SHOW);
    },
    showFullRange() {
      this.$emit('show-full-range');
    },
    showOverviewMap() {
      this.$emit('show-overview-map');
    },
    showHistoricalData() {
      this.$emit('show-historical-data');
    },
    toggleZoomMode() {
      this.$store.commit(MAP_ZOOM_MODE_TOGGLE);
    },
    showAddLayerFromFile() {
      if (this.$store.getters.temporaryLayers.length > 0) {
        const self = this;
        this.showTemporaryLayersConfirmation(() => {
          self.$store.commit(WINDOW_GET_LAYER_FROM_FILE_SHOW);
        });
      } else {
        this.$store.commit(WINDOW_GET_LAYER_FROM_FILE_SHOW);
      }
    },
    manualImportPanelShow() {
      this.$store.commit(MANUAL_IMPORT_PANEL_VISIBLE_SET, true);
    },
    showAskForArchiveData() {
      if (this.$context.hasPermission('Request_for_archive_data')) {
        this.$store.commit(WINDOW_ASK_FOR_ARCHIVE_DATA_SHOW);
      }
    },
    showAddLayerFromService() {
      if (this.$store.getters.temporaryLayers.length > 0) {
        const self = this;
        this.showTemporaryLayersConfirmation(() => {
          self.$store.commit(WINDOW_ADD_LAYER_FROM_SERVICE_SHOW);
        });
      } else {
        this.$store.commit(WINDOW_ADD_LAYER_FROM_SERVICE_SHOW);
      }
    },
    showMapShortcuts() {
      this.$store.commit(WINDOW_MAP_SHORTCUTS_SHOW);
    },
    startFeatureInfo() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie tego przycisku pozwoli odczytywać informacje o danym obiekcie z mapy.',
        });
      } else {
        this.$store.dispatch(TOGGLE_GET_FEATURE_INFO);
      }
    },
    toggleAttributesTable() {
      this.$store.commit(FEATURES_TABLE_TOGGLE);
      // this.$store.dispatch(FEATURES_FETCH, {
      //   _this: this,
      //   pageNumber: 1,
      //   pageSize: 200
      // });
      // this.$store.commit('setIsResponseObjectsLessThanPageSize', false);
      // this.$store.commit('setPreviousIterationFeaturesSize', 0);
      // this.$store.commit('setIsRequestRepeatedForBiggerPageSize', false);
    },
    async activateEditSession() {
      this.$store.dispatch(EDIT_SESSION_START);
    },
    requestNotification() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie tego przycisku spowoduje przełączenie narzędzia zgłoszenia popytu.',
        });
      } else {
        this.$store.dispatch(TOGGLE_REPORT_DEMAND);
        this.$emit('toggle-request-notification');
      }
    },
    addFeature() {
      this.$emit('add-feature');
    },
    editFeature() {
      this.$emit('edit-feature');
    },
    deleteFeature() {
      this.$emit('delete-feature');
    },
    copyFeature() {
      this.$emit('copy-feature');
    },
    moveToArchiveFeature() {
      this.$emit('remove-feature', false);
    },
    removeFeature() {
      this.$emit('remove-feature', true);
    },
    replaceGeometry() {
      this.$emit('replace-geometry');
    },
    deactivateRangeSelection() {
      this.$store.commit(REPORTS_RANGE_SELECTION_ACTIVATE, false);
    },
    toggleSelectMode(mode) {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie tego przycisku spowoduje zmianę funkcji narzędzia myszki.',
        });
      } else {
        this.$emit('toggle-select-mode', mode);
      }
    },
    showSpatialAnalysisModal() {
      if (
        this.connectionAnalysisLaunched ||
        this.roadLaneAnalysisStarted ||
        this.poleAnalysisReady
      ) {
        this.$notify({
          type: 'warn',
          title: 'Ostrzeżenie.',
          text: 'Należy wyłączyć trwającą analizę.',
        });
      } else {
        this.$store.commit(SPATIAL_ANALYSIS_SHOW_MODAL);
      }
    },
    togglePoleAnalysis() {
      if (this.$context.hasPermission('Analysis_pole_usage_costs')) {
        if (this.roadLaneAnalysisStarted || this.connectionAnalysisLaunched) {
          this.$notify({
            type: 'warn',
            title: 'Ostrzeżenie.',
            text: 'Należy wyłączyć trwającą analizę.',
          });
        } else if (this.poleAnalysisReady) {
          this.$store.dispatch(CANCEL_POLE_ANALYSIS);
        } else {
          this.$store.dispatch(BEGIN_POLE_ANALYSIS);
        }
      }
    },
    toggleRoadLaneAnalysis() {
      if (this.$context.hasPermission('Analysis_road_line_occupation_costs')) {
        if (this.poleAnalysisReady || this.connectionAnalysisLaunched) {
          this.$notify({
            type: 'warn',
            title: 'Ostrzeżenie.',
            text: 'Należy wyłączyć trwającą analizę.',
          });
        } else if (this.roadLaneAnalysisStarted) {
          this.$store.dispatch(STOP_ROAD_LANE_ANALYSIS);
        } else {
          this.$store.dispatch(BEGIN_ROAD_LANE_ANALYSIS);
        }
      }
    },
    toggleSetFeatureGeometryTool() {
      this.$emit('toogle-set-feature-geometry-tool');
    },
    showSpatialTabs() {
      this.$store.dispatch(SPATIAL_TABS_SHOW_MODAL);
    },
    startMeasurement(type) {
      this.measurementPopoverHidden();
      this.$store.dispatch(MEASUREMENTS_ENABLE, {
        type: type,
        unit: this.measurementUnit,
      });
    },
    measurementToolClick() {
      if (this.measurementsEnabled) {
        this.$store.commit(MEASUREMENTS_ENABLED_SET, false);
        return false;
      }

      this.measurementPopoverVisible = true;
      this.$nextTick(function () {
        this.$refs.measurementToolda.focus();
        this.$refs.measurementToolda.click();
      });
    },
    measurementPopoverHidden() {
      this.measurementPopoverVisible = false;
    },
    mapPrintoutClick() {
      this.mapPrintoutPopoverVisible = true;
    },
    mapPrintoutPopoverHidden() {
      this.mapPrintoutPopoverVisible = false;
    },
    showZoomToOwnRangeModal() {
      this.$store.commit(WINDOW_ZOOM_TO_OWN_RANGE_SHOW);
    },
    toggleConnectionAnalysis() {
      if (this.poleAnalysisReady || this.roadLaneAnalysisStarted) {
        this.$notify({
          type: 'warn',
          title: 'Ostrzeżenie.',
          text: 'Należy wyłączyć trwającą analizę.',
        });
      } else {
        this.$store.commit(CONNECTION_ANALYSIS_TOGGLE);
      }
    },
    editVertices() {
      this.$emit('edit-many-vertices');
    },
    copyFragment() {
      this.$emit('copy-fragment');
    },
    toggleMismatchApplicationVisibility() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie tego przycisku spowoduje przełączenie narzędzia zgłoszenia robieżności.',
        });
      } else {
        this.$emit('toggle-mismatch-application-visibility');
      }
    },
    getParamValueFromUrl(param) {
      var results = new RegExp('[?&]' + param + '=([^&#]*)').exec(
        window.location.href
      );
      if (results == null) {
        return null;
      } else {
        return decodeURI(results[1]) || 0;
      }
    },
    downloadMap(config) {
      switch (config.format) {
        case 'png':
          this.downloadPngMap();
          break;
        case 'jpg':
          this.downloadJpgMap();
          break;
        case 'pdf':
          this.downloadPdfMap();
          break;
        default:
          this.downloadPngMap();
      }
    },
    downloadPngMap() {
      const dataURL = this.getMapPng();
      const link = document.createElement('a');
      link.href = dataURL;
      link.download = 'Zdjęcie mapy.png';
      link.click();
      // document.body.removeChild(link);
      link.remove();
    },
    downloadJpgMap() {
      const dataURL = this.getMapPng();
      const link = document.createElement('a');
      link.href = dataURL;
      link.download = 'Zdjęcie mapy.jpg';
      link.click();
      link.remove();
    },
    convertPngtoBase64(dataURL) {
      return dataURL.split(',')[1];
    },
    getMapPng() {
      const mapContainer = document.getElementById('map');
      if (!mapContainer) {
        console.error('Map container element not found.');
        return;
      }

      const mapRendererCanvas = mapContainer.querySelector('canvas');
      if (!mapRendererCanvas) {
        console.error('Map renderer canvas not found.');
        return;
      }

      const captureCanvas = document.createElement('canvas');
      captureCanvas.width = mapRendererCanvas.width;
      captureCanvas.height = mapRendererCanvas.height;
      captureCanvas.setAttribute('crossorigin', 'anonymous');
      const context = captureCanvas.getContext('2d');

      context.drawImage(mapRendererCanvas, 0, 0);

      const image = new Image();
      image.crossOrigin = '*';

      image.src = captureCanvas.toDataURL('image/png');

      // Open the screenshot in a new window or do any other processing
      // const link = document.createElement('a');
      // link.href = dataURL;
      // link.download = 'map_screenshot.png';

      // Simulate a click event on the link to trigger the download
      // link.click();
      return image.src;
    },
    async downloadPdfMap() {
      await this.postExportPdfMap();
    },
    async postExportPdfMap() {
      try {
        this.base64Png = null;
        this.base64Png = this.convertPngtoBase64(this.getMapPng());
        const api = new SearchApi();
        const response = await api.postExportPdfMap(
          {
            body: {
              image: this.base64Png || null,
            },
          },
          {
            ignoreGlobalError: true,
            download: true,
            withCredentials: false,
            hasContentType: false,
            jsonData: true,
          }
        );
        if (response) {
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title: 'Uwaga.',
        });
      }
    },
    showConfirmation(message, yesAction, noAction) {
      const confirmationWindow = this.$refs.confirmationWindow;
      confirmationWindow.setMessage(message);
      confirmationWindow.setYesAction(yesAction);
      confirmationWindow.setNoAction(noAction);
      confirmationWindow.show();
    },
    showTemporaryLayersConfirmation(yesAction) {
      this.showConfirmation(
        `<b>Czy na pewno chcesz przejść do formularza dodawania warstwy?</b> <br/>
        Masz niezapisane warstwy użytkownika. Dodanie nowej warstwy odświeży listę i usunie wszystkie niezapisane warstwy użytkownika.`,
        yesAction
      );
    },
    togglehistoryTimelineActive() {
      this.$store.commit(TOGGLE_HISTORY_TIMELINE_ACTIVE);
    },
    showToolbarContextHelp() {
      this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
        message: 'Przycisk ten pozwala pokazać i ukryć wstążkę z narzędziami.',
      });
    },
  },
  mounted() {
    const searchQuerry = window.location.search;
    if (searchQuerry.includes('?historyTimelineActive=true')) {
      this.togglehistoryTimelineActive();
    }
  },
  created() {
    const self = this;

    // selection should be enabled by default on mobile devices
    if (self.isMobileWidth) {
      self.toggleSelectMode(self.pointSelect);
    }

    self.$store.watch(
      () => self.$store.getters.currentShortcuts,
      (value, oldValue) => {
        if (value.indexOf(KeyShortcuts.previousView) >= 0) {
          self.moveBack();
        }

        if (value.indexOf(KeyShortcuts.nextView) >= 0) {
          self.moveForward();
        }

        if (value.indexOf(KeyShortcuts.selectMany) >= 0) {
          self.$store.commit(SELECT_MULTIPLE_ACTIVATE, true);
        } else {
          self.$store.commit(SELECT_MULTIPLE_ACTIVATE, false);
        }

        if (value.indexOf(KeyShortcuts.toggleRuler) >= 0) {
          self.measurementToolClick();
        }

        if (value.indexOf(KeyShortcuts.addWms) >= 0) {
          self.showAddLayerFromService();
        }

        if (value.indexOf(KeyShortcuts.openAnalysis1) >= 0) {
          self.toggleRoadLaneAnalysis();
        }

        if (value.indexOf(KeyShortcuts.openAnalysis2) >= 0) {
          self.togglePoleAnalysis();
        }

        if (value.indexOf(KeyShortcuts.select) >= 0) {
          self.toggleSelectMode(self.pointSelect);
        }

        if (value.indexOf(KeyShortcuts.searchMetadata) >= 0) {
          self.toggleSearchPanelVisibility();
        }

        if (value.indexOf(KeyShortcuts.archiveData) >= 0) {
          self.showAskForArchiveData();
        }
      }
    );
  },
};
</script>

<style>
div.map-toolbar {
  pointer-events: none;
}

div.map-toolbar button {
  pointer-events: all;
}

.map-toolbar-dropdown {
  min-width: 0px;
}

.mode-active .btn {
  opacity: 0.65 !important;
}

.right-border {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.custom-margin {
  margin-right: 0.15rem;
}
</style>
